export default __webpack_public_path__ + "static/media/toast-error.976aa8fc.svg";